import { Alert, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import RouteRule from "./RouteRule";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import LoadingLogoPage from "../loadingPage/loadingPage";
import CustomButton from "../../reusableComponents/CustomButton";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import { colorBrandObject } from "../../../constants/brandings";
import "./routing.css";
// import RouteIcon from "@mui/icons-material/Route";
import RouteIcon from '../../../assets/svg/routing/routing-icon.svg'


import { isEmpty } from "../utils/utils";
import EmptyState from "./RuleView/EmptyState";
import HelpModal from "./modals/HelpModal";
import InputSearch from "../../reusableComponents/InputSearch/InputSearch";
import AnimatedReorderList from "../../reusableComponents/DragAndDrop/AnimatedReorderList";

function Routing(operationPermissions) {
  const [rulesData, setRulesData] = useState([]);
  const [businessUnitOptions, setBusinessUnitOptions] = useState([]);
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isCreateRule, setIsCreateRule] = useState(false);
  const [newRuleLoader, setNewRuleLoader] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [editRuleData, setEditRuleData] = useState("");
  const createRuleRef = useRef(null);
  const [ruleUpdateLoader, setRuleUpdateLoader] = useState(false);
  const [isRuleAvailable, setIsRuleAvailable] = useState(true)


  // TODO :- Remove old urls for the routings 

  const {
    getRouteRuleData,
    getAllModalData,
    getAllPspConfigs,
    updateRoutingRule,
    isAuthorizedPermission
  } = useAuth();

  const routeRuleRef = useRef(null);

  const getRuleData = (isLoader, filter) => {
    if (isLoader) setLoader(true);
    let reqData = {
      limit: 100,
      sort: {
        sequence: "asc"
      }
    };
    if (filter?.attrName) {
      const search = {
        attrName: filter.attrName,
        operator: "containsIgnoreCase",
        values: [filter.value || ""],
      }
      reqData.advancedAttributeFilters = [search]
    }
    getRouteRuleData(
      reqData,
      (data) => {
        const routingRulesData = data?.points;
        if (!routingRulesData?.length && !filter?.attrName) setIsRuleAvailable(false)

        setRulesData(routingRulesData);
        setLoader(false);
      },
      function (errMsg) {
        setLoader(false);
        customToast("error", "high", errMsg || "Something Went Wrong ");
      }
    );
  };
  const getInitialData = async () => {
    try {
      setLoader(true);

      getAllModalData(
        function (data) {
          let businessUnit = data?.legalEntities;
          if (businessUnit?.length) {
            businessUnit = businessUnit.map((el) => ({
              title: el.name,
              value: el.code,
            }));
            setBusinessUnitOptions(businessUnit);
            getAllPspConfigs((data) => {
              setPaymentGateways(
                data.map((pspConfig) => {
                  return {
                    title: pspConfig.title,
                    value: pspConfig.pspCode,
                    logoUrl: pspConfig.pspLogoUrl,
                  };
                })
              );
              getRuleData();
            });
          }
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    } catch (err) { }
  };

  const handleCreateNewRule = async () => {
    if (isCreateRule) {
      setNewRuleLoader(true);
      if (routeRuleRef?.current && routeRuleRef.current.businessUnit) {
        await routeRuleRef.current.submitForm("DRAFT", false);

        routeRuleRef.current.resetData();
      }
      createRuleRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
      setNewRuleLoader(false);
    } else {
      setIsCreateRule(true);
    }
  };


  const handleChangeOrder = async (data, index, action, moveItem) => {
    try {
      const { name, routeTo, criteria, legalEntityCode, status, dynamicRoutingFallback, } = data;
      const payload = {
        name,
        routeTo: routeTo || null,
        criteria: criteria || null,
        legalEntityCode,
        status,
        dynamicRoutingFallback,
      };
      if (action == "up") {
        payload.prevRuleId = rulesData[index - 2]
          ? rulesData[index - 2].ruleId
          : null;
        payload.nextRuleId = rulesData[index - 1]
          ? rulesData[index - 1].ruleId
          : null;
      } else {
        payload.nextRuleId = rulesData[index + 2]
          ? rulesData[index + 2].ruleId
          : null;
        payload.prevRuleId = rulesData[index + 1]
          ? rulesData[index + 1].ruleId
          : null;
      }
      setRuleUpdateLoader(true);
      await updateRoutingRule(
        rulesData[index].ruleId,
        payload,
        () => {
          moveItem(index, action)
        },
        (errMsg, err) => () => {
          customToast("error", "high", "Failed to change the order ");
        }
      );
    } catch (err) {
      customToast("error", "high", "Failed to change the order ");
    } finally {
      setRuleUpdateLoader(false);
    }
  };

  const handleCopyAndPastRule = (data) => {
    setEditRuleData({ ...data, name: "", ruleId: "" });
    handleCreateNewRule();
  };

  useEffect(() => {
    getInitialData();
  }, []);

  useEffect(() => {
    if (isCreateRule) {
      if (createRuleRef.current) {
        setTimeout(() => {
          createRuleRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end"
          });
        })
      }
    } else {
      setEditRuleData("");
    }
  }, [isCreateRule]);



  const handleItemsChange = (newOrder) => {
    setRulesData(newOrder);
  };
  return (
    <div className="content-wrapper" style={{ background: "white" }}>
      <section className="content">

        {loader ? (
          <LoadingLogoPage />
        ) : (
          <>
            <ContentHeader
              firstHeading={
                !isRuleAvailable && !isCreateRule
                  ? "Routing"
                  : "Routing Rules"
              }
              secondHeading={<div className="">
                {isRuleAvailable && <Alert
                  style={{
                    backgroundColor: "#FEFFE6",
                    padding: 1,
                    display: "inline-block",
                    marginTop: "6px",
                    "& .MuiAlert-message": {
                      padding: 0,
                    },
                  }}
                  icon={false}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      padding: "0 5px"
                    }}
                  >
                    <img src="/assets/info-circle-yellow.svg" />

                    <div>
                      <Typography
                        style={{
                          color: " var(--Global-Neutral-Grey-1300, #0A090B)",
                          fontSize: "12px",
                          fontWeight: 400,
                          textAlign: "left",
                        }}
                      >
                        In the event of conflicting rules, the transaction
                        will adhere to the rules in listed order.
                      </Typography>
                    </div>
                  </div>
                </Alert>}
              </div>}
              icon={
                <RouteIcon
                  style={{ color: colorBrandObject.sideBarSelectedOptionBackground }}
                />
              }
            />
            {!isRuleAvailable && !isCreateRule ? (
              <EmptyState handleSetupRule={handleCreateNewRule} />
            ) : (
              <div className="reportMainDiv">


                <div>

                  <div
                    className="d-flex align-items-center  justify-content-between"
                    style={{ marginTop: "15px" }}
                  >
                    <div style={{ width: "70%" }}>
                      <InputSearch
                        dropdownOptions={[
                          { value: "name", label: "Rule Name" },
                        ]}
                        onSearch={(attrName, value) => getRuleData(false, { attrName, value })}
                        placeholder="Search Rules"
                        defaultSearchAttribute="name"
                      />
                    </div>

                    {
                      isAuthorizedPermission(operationPermissions?.addRoutingRule) && (
                        <CustomButton
                          text={"Create New Rule"}
                          type={"primary"}
                          onClick={handleCreateNewRule}
                          variant={"contained"}
                          loading={newRuleLoader}
                        />
                      )
                    }

                  </div>
                  {rulesData?.length > 0 && (
                    <>
                      <AnimatedReorderList
                        items={rulesData}
                        id={"ruleId"}
                        onItemsChange={handleItemsChange}
                        itemRenderer={(el, index, moveItem) => {
                          return <RouteRule
                            key={el?.ruleId}
                            data={el}
                            operationPermissions={operationPermissions}
                            businessUnitOptions={businessUnitOptions}
                            paymentGateways={paymentGateways}
                            getRuleData={getRuleData}
                            setRulesData={setRulesData}
                            setShowHelpModal={setShowHelpModal}
                            handleCopyAndPastRule={handleCopyAndPastRule}
                            dataLength={rulesData?.length}
                            index={index}
                            ruleUpdateLoader={ruleUpdateLoader}
                            setIsRuleAvailable={setIsRuleAvailable}
                            handleChangeOrder={(action) =>
                              handleChangeOrder(el, index, action, moveItem)
                            }
                          />
                        }}
                      />
                    </>
                  )}
                  {!isCreateRule && !rulesData?.length && <p className="text-center" style={{ marginTop: "200px", fontSize: "16px", fontWeight: "500" }}>No Rules Found</p>}
                  {isCreateRule && (
                    <div ref={createRuleRef}>
                      <RouteRule
                        setIsRuleAvailable={setIsRuleAvailable}
                        getRuleData={getRuleData}
                        setRulesData={setRulesData}
                        businessUnitOptions={businessUnitOptions}
                        paymentGateways={paymentGateways}
                        isCreateRule={isCreateRule}
                        operationPermissions={operationPermissions}
                        setIsCreateRule={setIsCreateRule}
                        ref={routeRuleRef}
                        data={editRuleData}
                        setShowHelpModal={setShowHelpModal}
                        dataLength={rulesData?.length}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}

        {showHelpModal && (
          <HelpModal isOpen={showHelpModal} setIsOpen={setShowHelpModal} />
        )}
      </section>
    </div>
  );
}

export default Routing;
